import { Divider } from '@components/core-ui/Divider';
import LockedJob from '@components/icons/LockedJob.svg';
import AdminsIcon from '@components/icons/AdminsIcon.svg';
import BillingAccountsIcon from '@components/icons/BillingAccountsIcon.svg';
import Briefcase from '@components/icons/Briefcase.svg';
import CanvasIcon from '@components/icons/CanvasIcon.svg';
import CloudIcon from '@components/icons/CloudIcon.svg';
import DiffIcon from '@components/icons/DiffIcon.svg';
import FileDocumentIcon from '@components/icons/FileDocument.svg';
import HistoryIcon from '@components/icons/History.svg';
import JobReportsIcon from '@components/icons/JobReports.svg';
import OrganizationsIcon from '@components/icons/OrganizationsIcon.svg';
import PromptsIcon from '@components/icons/PromptsIcon.svg';
import SettingsIcon from '@components/icons/SettingsIcon.svg';
import StarIcon from '@components/icons/StarIcon.svg';
import SubscriptionsIcon from '@components/icons/Subscriptions.svg';
import TransactionsIcon from '@components/icons/TransactionsIcon.svg';
import UsersIcon from '@components/icons/Users.svg';
import WorkspaceIcon from '@components/icons/WorkspaceIcon.svg';
import DashboardIcon from '@components/icons/Dashboard.svg';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import MicrophoneIcon from '@components/icons/Microphone.svg';
import SMSWhitelistIcon from '@components/icons/SMSWhitelist.svg';
import { SidebarLink } from '../SidebarLink';

export const AdminMenu = () => {
  const { me } = useAuthContext();
  const isSuperAdmin = me?.roles?.includes('ROLE_SUPER_ADMIN');
  const isVsBilling = me?.roles?.includes('ROLE_BILLING_ADMIN');
  return (
    <>
      <SidebarLink
        to={routes.adminDashboard.make()}
        text="Dashboard"
        Icon={DashboardIcon}
        iconOffset={3}
        activeRoutes={[routes.adminDashboard.make()]}
      />
      <SidebarLink
        to={routes.adminOrganizationsList.make()}
        text="Organizations"
        Icon={OrganizationsIcon}
        iconOffset={2}
        activeRoutes={[routes.adminOrganizationsList.make()]}
      />
      <SidebarLink
        to={routes.adminCloudLayouts.make()}
        text="Cloud Layouts"
        Icon={CloudIcon}
        iconOffset={2}
        activeRoutes={[routes.adminCloudLayouts.make()]}
      />
      <SidebarLink
        to={routes.adminWorkspacesList.make()}
        text="Workspaces"
        Icon={WorkspaceIcon}
        iconOffset={2}
        activeRoutes={[routes.adminWorkspacesList.make()]}
      />
      <SidebarLink
        to={routes.adminUsersList.make()}
        text="Users"
        Icon={UsersIcon}
        iconOffset={2}
        activeRoutes={[routes.adminUsersList.make()]}
      />
      <SidebarLink
        to={routes.adminAuditLogs.make()}
        text="Audit Log"
        Icon={HistoryIcon}
        iconOffset={2}
        activeRoutes={[routes.adminAuditLogs.make()]}
      />
      <SidebarLink
        to={routes.adminAttorneyUsers.make()}
        text="Attorneys Access"
        Icon={LockedJob}
        iconOffset={2}
        activeRoutes={[
          routes.adminAttorneysAccess.make(),
          routes.adminAttorneyUsers.make(),
          routes.adminAttorneysPasscodes.make(),
        ]}
      />
      <SidebarLink
        to={routes.adminCanvasCoursesList.make()}
        text="Canvas"
        Icon={CanvasIcon}
        iconOffset={2}
        activeRoutes={[routes.adminCanvasCoursesList.make()]}
      />

      {isVsBilling ? (
        <>
          <Divider className="divider" />
          <SidebarLink
            to={routes.adminSubscriptions.make()}
            text="Subscriptions"
            Icon={SubscriptionsIcon}
            iconOffset={1}
            activeRoutes={[routes.adminSubscriptions.make()]}
          />
          <SidebarLink
            to={routes.adminBillingAccountsList.make()}
            text="Billing Accounts"
            Icon={BillingAccountsIcon}
            iconOffset={0}
            activeRoutes={[routes.adminBillingAccountsList.make()]}
          />
          <SidebarLink
            to={routes.adminTransactions.make()}
            text="Transactions"
            Icon={TransactionsIcon}
            iconOffset={3}
            activeRoutes={[routes.adminTransactions.make(), routes.adminTransactionCodesList.make()]}
          />
          <SidebarLink
            to={routes.adminJobsReport.make()}
            text="Jobs Report"
            Icon={JobReportsIcon}
            iconOffset={4}
            activeRoutes={[routes.adminJobsReport.make()]}
          />
        </>
      ) : null}

      {isSuperAdmin ? (
        <>
          <Divider className="divider" />
          <SidebarLink
            to={routes.adminAdminsList.make()}
            text="Admin Management"
            Icon={AdminsIcon}
            iconOffset={0}
            activeRoutes={[routes.adminAdminsList.make()]}
          />
        </>
      ) : null}

      <Divider className="divider" />
      <SidebarLink
        to={routes.adminDiff.make()}
        text="Diff Tool"
        Icon={DiffIcon}
        iconOffset={0}
        activeRoutes={[routes.adminDiff.make()]}
      />
      <SidebarLink
        to={routes.adminPrompts.make()}
        text="LLM Prompts"
        Icon={PromptsIcon}
        iconOffset={4}
        activeRoutes={[routes.adminPrompts.make()]}
      />
      <SidebarLink
        to={routes.adminComponentShowcase.make()}
        text="Component showcase"
        Icon={StarIcon}
        iconOffset={0}
        activeRoutes={[routes.adminComponentShowcase.make()]}
      />
      <SidebarLink
        to={routes.adminAsrProxyConsole.make()}
        text="ASR Console"
        Icon={MicrophoneIcon}
        iconOffset={2}
        activeRoutes={[routes.adminAsrProxyConsole.make()]}
      />
      <SidebarLink
        to={routes.adminApiDocs.make()}
        text="API Docs"
        Icon={FileDocumentIcon}
        iconOffset={2}
        activeRoutes={[
          routes.adminApiDocs.make(),
          routes.adminApiDocsOrganizationApi.make(),
          routes.adminApiDocsInternalApi.make(),
        ]}
      />
      <Divider className="divider" />
      <SidebarLink
        to={routes.adminSMSCountries.make()}
        text="SMS"
        Icon={SMSWhitelistIcon}
        iconOffset={0}
        activeRoutes={[routes.adminSMSCountries.make(), routes.adminSMSWhitelist.make()]}
      />
      <SidebarLink
        to={routes.adminSSOProvidersList.make()}
        text="SSO Providers"
        Icon={Briefcase}
        iconOffset={0}
        activeRoutes={[routes.adminSSOProvidersList.make()]}
      />
      <SidebarLink
        to={routes.adminFeatureFlags.make()}
        text="Feature Flags"
        Icon={StarIcon}
        iconOffset={0}
        activeRoutes={[routes.adminFeatureFlags.make(), routes.adminAttorneyViewFeatureFlags.make()]}
      />
      <SidebarLink
        to={routes.adminSettings.make()}
        text="Settings"
        Icon={SettingsIcon}
        iconOffset={0}
        activeRoutes={[routes.adminSettings.make()]}
      />
    </>
  );
};
